import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';

import {
  EnumBusiness,
  EnumCooperateType,
  EnumLoginWay,
  EnumPartnerTier,
  EnumRelSubType,
  EnumUserType,
} from '../../enums';
import { Regulars } from '../../helpers/regulars';
import { onCreateFactoryAuth } from './auth';

@BindAll()
class UserModel {
  static UserModel: UserModel;
  /**
   * 工厂函数
   * @static
   * @return {*}
   * @memberof UserModel
   */
  static onCreateFactoryUser() {
    if (!lodash.isEmpty(UserModel.UserModel)) {
      return UserModel.UserModel;
    }
    return new UserModel();
  }
  // 单例模式 全局唯一
  constructor() {
    // 客户端开启单例
    if (typeof window !== 'undefined') {
      UserModel.UserModel = this;
    }
  }
  Auth = onCreateFactoryAuth();
  /**
   * 兼容 之前的 value
   * @readonly
   * @memberof UserModel
   */
  @computed
  get value() {
    return lodash.assign({}, this.Auth.Info);
  }
  /**
   * 兼容 之前的方法
   */
  merge(value = {}) {
    value = lodash.merge({}, this.value, value);
    this.Auth.onSaveInfo(value);
  }
  /**
   * 兼容 之前的方法
   */
  set(value = {}) {
    this.Auth.onSaveInfo(value);
  }
  // toggleLoading(loading){
  // }
  /**
   * 对比Token 信息
   * @param {*} AccessToken
   * @return {*}
   * @memberof UserModel
   */
  eqAccessToken(AccessToken) {
    AccessToken = lodash.defaultTo(AccessToken, this.Auth.AccessToken);
    return lodash.eq(lodash.get(this.value, 'AccessToken'), AccessToken);
  }
  /** 用户身份类型 */
  @computed
  public get aud() {
    return lodash.get(this.Auth.JwtDecoded, 'aud', '');
  }
  /** 用户名 */
  @computed
  public get username() {
    return lodash.get(this.Auth.JwtDecoded, 'username', '');
  }

  /** 身份id */
  @computed
  public get identityId() {
    return (
      lodash.get(this.Auth.JwtDecoded, 'identityId') ||
      lodash.get(this.Auth.JwtDecoded, 'identityIds')
    );
  }
  /** user code  */
  @computed
  public get userCode() {
    return lodash.get(this.Auth.JwtDecoded, 'sub');
  }
  /** 登录来源 */
  @computed
  public get loginWay() {
    return lodash.get(this.Auth.JwtDecoded, 'loginWay', '');
  }

  /** lenovoid登录 */
  @computed
  public get isLidLogin() {
    return lodash.eq(this.loginWay, EnumLoginWay.LENOVO_LOGIN);
  }
  @computed
  public get userId() {
    return lodash.get(this.value, 'userId');
  }
  /** 姓名 */
  @computed
  public get realName() {
    return lodash.get(this.value, 'realName');
  }
  /** 邮箱 */
  @computed
  public get email() {
    return lodash.get(this.value, 'email');
  }

  /** 是否完善信息 姓名 */
  @computed
  public get isPerfectInfo() {
    return this.realName;
  }

  /** 用户地址*/
  @computed
  get userAddress() {
    return lodash.get(this.value, 'userAddress', '');
  }

  /** 是否完善信息 */
  get isRealNameAddress() {
    if (this.isKLogin || this.isDLogin) {
      return this.realName;
    }
    return this.realName && !lodash.isEmpty(this.userAddress);
  }

  /** 12位是否是新用户 */
  get isNewUser() {
    return (
      lodash.includes([1, 2], lodash.get(this.value, 'status')) &&
      this.is12Login
    );
  }

  /** 是否企业认证 */
  @computed
  public get isAttestation() {
    return lodash.get(this.value, 'verifiedStatus', false);
  }

  /** 企业认证是否ocr通过 */
  @computed
  public get isOcrCheckAttestation() {
    return lodash.get(this.value, 'ocrCheckStatus', false);
  }

  /** 企业认证是否人工审核通过 */
  @computed
  public get isManualReviewAttestation() {
    return lodash.get(this.value, 'manualReviewStatus', false);
  }

  /** 渠道等级 */
  @computed
  public get partnerTier() {
    return lodash.get(this.value, 'partnerTier', '');
  }

  /** 当前身份集合 */
  @computed
  get currentIdentityVOList() {
    return lodash.get(this.value, 'currentIdentityVOList', []);
  }

  /** 用户当前渠道类型子类型 */
  @computed
  get channelTypeList() {
    return lodash.flattenDepth(
      lodash.map(this.currentIdentityVOList, 'channelTypeList'),
    );
  }

  /**bu是SMB 并且 typeId为19 是商用服务商 是T1（特殊身份）*/
  @computed
  get isTypeId19() {
    return lodash.some(this.channelTypeList, (channel) => {
      return lodash.eq(lodash.get(channel, 'typeId'), '19');
    });
  }

  //partnerTier是1
  @computed
  get isPartnerTierEqT1() {
    return lodash.eq(this.partnerTier, EnumPartnerTier.T1);
  }

  //是否T1身份
  @computed
  get isT1() {
    if (this.isSMB && this.isTypeId19) {
      return true;
    }
    return lodash.eq(this.partnerTier, EnumPartnerTier.T1);
  }
  //是否T2身份
  @computed
  get isT2() {
    if (this.isSMB && this.isTypeId19) {
      return false;
    }
    return lodash.eq(this.partnerTier, EnumPartnerTier.T2);
  }
  //是否服务站账号
  @computed
  get isServiceStation() {
    return lodash.eq(this.partnerTier, EnumPartnerTier.ServiceStation);
  }

  //是否L2
  @computed
  get isL2() {
    return this.isPartnerTierEqT1;
  }

  //是否L2，10位或者12位账号登录
  @computed
  get is10Or12LoginL2() {
    return (
      this.is10Or12Login && lodash.eq(this.partnerTier, EnumPartnerTier.T1)
    );
  }
  // ISG的L2
  // BU为ISG的L2 在特定情况需要转成L1使用
  @computed
  get isIsgL2() {
    return this.isL2 && this.isISG;
  }
  // L2
  @computed
  get isNotIsgL2() {
    return this.isL2 && !this.isISG;
  }

  //是否SI
  @computed
  get isSI() {
    return (
      lodash.eq(this.partnerTier, EnumPartnerTier.T1) && this.isRegisterPartner
    );
  }

  /** 企业信息 */
  @computed
  public get companyInfo() {
    return lodash.get(this.value, 'companyCoreResponse', {});
  }

  /** 手机号 */
  // @computed
  // public get mobile() {
  //   return lodash.get(this.value, 'mobile');
  // }

  /** 是否需要选择身份 */
  @computed
  public get optionIdentity() {
    return lodash.eq(lodash.get(this.value, 'optionIdentity'), true);
  }

  /** 渠道编码 */
  @computed
  public get channelId() {
    return lodash.get(this.value, 'channelId');
  }

  /** 企业名称 */
  @computed
  public get companyName() {
    return (
      lodash.get(this.value, 'companyName') ||
      lodash.get(this.value, 'companyCoreResponse.companyName') ||
      '无'
    );
  }

  /** 是否是k码登录 */
  @computed
  public get isKLogin() {
    return lodash.startsWith(
      lodash.toLower(this.username),
      lodash.toLower('k'),
    );
  }

  /**
   * 是否D码登录
   */
  @computed
  get isDLogin() {
    return lodash.startsWith(
      lodash.toLower(this.username),
      lodash.toLower('d'),
    );
  }

  /**
   * 是否K或者D码登录
   */
  @computed
  get isKorDLogin() {
    return this.isKLogin || this.isDLogin;
  }

  /**
   * 是否手机号登录
   */
  @computed
  get isMobileLogin() {
    return Regulars.mobile_phone.test(this.username);
  }

  /**
   * 是否10位账号登录
   */
  @computed
  get is10Login() {
    return (
      Regulars.number.test(this.username) && lodash.size(this.username) == 10
    );
  }

  /**
   * 是否12位账号登录
   */
  @computed
  get is12Login() {
    return (
      Regulars.number.test(this.username) && lodash.size(this.username) == 12
    );
  }

  /**
   * 是否10位或者12位账号登录
   */
  @computed
  get is10Or12Login() {
    return this.is10Login || this.is12Login;
  }

  /**
   * 是否12位01主账号登录
   */
  @computed
  get is12MainLogin() {
    return this.is12Login && lodash.endsWith(this.username, '01');
  }

  /** 是否是多个身份 */
  @computed
  public get isMultipleIndentity() {
    return lodash.size(lodash.get(this.value, 'indentityList', [])) > 1;
  }

  /** 是否允许切换身份 */
  @computed
  public get isAllowChangeId() {
    return !this.isSales && !this.isKLogin && this.isMultipleIndentity;
  }

  /** BU */
  @computed
  public get BU() {
    return lodash.get(this.value, 'businessType');
  }

  /** 是否是游客 */
  @computed
  public get isTourists() {
    return lodash.isEmpty(this.value.AccessToken);
  }

  /** 是否是isg */
  @computed
  public get isISG() {
    return lodash.eq(this.BU, EnumBusiness.ISG);
  }

  /** 是否是意向isg */
  @computed
  public get isIntendedISG() {
    let intentionBu = lodash.get(this.value, 'intentionBu');
    return lodash.eq(intentionBu, EnumBusiness.ISG);
  }

  /** 是否是T1用户 */
  //   @computed
  //   public get isT1() {
  //     const channelTypeList = lodash.get(this.value, 'channelTypeList');
  //     return lodash.some(channelTypeList, (item) => {
  //       return item.typeId == '19';
  //     });
  //   }

  /** 是否是CON */
  @computed
  public get isCON() {
    return lodash.eq(this.BU, EnumBusiness.CON);
  }

  /** 是否是REL */
  @computed
  public get isREL() {
    return lodash.eq(this.BU, EnumBusiness.REL);
  }

  /** 是否是SMB */
  @computed
  public get isSMB() {
    /** 如果存在意向伙伴等其它身份*/
    // if (this.isIntendedPartner) {
    //   return false;
    // }
    return lodash.eq(this.BU, EnumBusiness.SMB);
  }

  /** 是否是Service-B */
  @computed
  public get isSERVICEB() {
    return lodash.eq(this.BU, EnumBusiness.SERVICEB);
  }

  /** 是否是CON 或者 ISG */
  @computed
  public get isConorIsg() {
    return this.isCON || this.isISG;
  }

  /** 是否是游客-除smb 以外的其他游客身份 */
  @computed
  public get isNotSMBTourists() {
    return lodash.isEmpty(this.value.AccessToken) && !this.isSMB;
  }

  @computed
  public get isPLATFORM() {
    return lodash.eq(this.BU, EnumBusiness.PLATFORM);
  }

  /** 角色 */
  @computed
  public get role() {
    return lodash.join(
      lodash.map(this.currentIdentityVOList, 'roleIdContent'),
      ',',
    );
  }

  /** 是否签约 */
  @computed
  public get isSign() {
    return lodash.some(this.currentIdentityVOList, { signingStatus: true });
  }

  /** 暂开扩展菜单 */
  @computed
  public get unfoldEllipsis() {
    return lodash.get(
      this.value,
      'ellipsis',
      !lodash.isEmpty(this.Auth.AccessToken),
    );
  }

  /** 用户类型 */
  @computed
  public get userType() {
    return lodash.get(this.value, 'userType');
  }
  /** 是否 Sales */
  @computed
  public get isSales() {
    return lodash.eq(this.userType, EnumUserType.Sales);
  }
  /** 仅仅为意向伙伴 没有BU身份*/
  @computed
  public get isOnlyIntendedPartner() {
    return lodash.eq(this.userType, EnumUserType.Intention) && !this.BU;
  }
  /** 是否 意向伙伴 */
  @computed
  public get isIntendedPartner() {
    return lodash.eq(this.userType, EnumUserType.Intention);
  }
  /** 是否 合作伙伴 */
  @computed
  public get isCooperativePartner() {
    return lodash.eq(this.userType, EnumUserType.Cooperation);
  }

  /** 合作类型 */
  @computed
  public get cooperateType() {
    return lodash.get(this.value, 'cooperateType');
  }
  /** 注册伙伴 */
  @computed
  public get isRegisterPartner() {
    return lodash.eq(this.cooperateType, EnumCooperateType.Registered);
    // return true
  }
  /** 签约伙伴 */
  @computed
  public get isSignPartner() {
    return lodash.eq(this.cooperateType, EnumCooperateType.Signing);
  }
  /** 店面伙伴 */
  @computed
  public get isStorePartner() {
    return lodash.eq(this.cooperateType, EnumCooperateType.Store);
  }
  /** 店面伙伴byBU */
  @computed
  public get isStorePartnerByBu() {
    return lodash.eq(this.cooperateType, EnumCooperateType.Store) && this.isSMB;
  }
  /** CON 签约伙伴 */
  @computed
  public get isCONSignPartner() {
    return this.isCON && this.isSignPartner;
  }
  /** 是否 用户等级 L2 : 意向伙伴 || 合作伙伴-签约伙伴未签约  只针对SMB */
  @computed
  public get isLevel2() {
    if (this.isSales) {
      return false;
    }
    return !this.isAttestation || (this.isSignPartner && !this.isSign);
  }
  /** 是否 用户等级 L3 : 注册伙伴 只针对SMB */
  @computed
  public get isLevel3() {
    return this.isRegisterPartner;
  }
  /** 是否 用户等级 L4 ： 签约伙伴、已签约 只针对SMB */
  @computed
  public get isLevel4() {
    return this.isSignPartner && this.isSign;
  }
  /** 是否 可以购买商品 */
  @computed
  public get isBus() {
    if (this.isSales) {
      return false;
    }
    return this.isLevel3 || this.isLevel4;
  }
  /** 是否 SMB TypeId 16,20 显示购物车 */
  @computed
  public get isSMB1620() {
    const isType = lodash.some(this.channelTypeList, (channel) => {
      return lodash.includes(['16', '20'], lodash.get(channel, 'typeId'));
    });
    return this.isSMB && isType;
  }
  /** 是否SMB注册商 */
  @computed
  public get isSmbRegistrar() {
    const isType = lodash.some(this.channelTypeList, (channel) => {
      return lodash.includes(['20'], lodash.get(channel, 'typeId'));
    });
    return this.isSMB && isType;
  }
  /** 是否SMB签约商 */
  @computed
  public get isSmbContractors() {
    const isType = lodash.some(this.channelTypeList, (channel) => {
      return lodash.includes(['16', '19'], lodash.get(channel, 'typeId'));
    });
    return this.isSMB && isType;
  }
  /** 用户类型 */
  @computed
  public get resellerType() {
    if (this.isSales) {
      return 'Sales';
    }
    return this.cooperateType || '未认证';
  }

  /** 用户等级 */
  @computed
  public get levelCode() {
    return lodash.get(this.value, 'levelCode');
  }

  /** token */
  // @computed
  // public get token() {
  //   return lodash.get(this.value, 'token');
  // }

  @computed
  public get id() {
    return lodash.get(this.value, 'id');
  }
  /** 用户分享码 ？？？？？？？？？？？？？？*/
  @computed
  public get shareCode() {
    return lodash.get(this.value, 'userId');
  }
  /** 用户名称 */
  @computed
  public get userName() {
    if (this.Auth.AccessToken) {
      return this.realName || '未设置名称';
    }
    return '请登录';
  }
  /** 头像 */
  @computed
  public get avatarUrl() {
    //  https://joeschmoe.io/api/v1/random 随机头像
    return lodash.get(
      this.value,
      'avatarUrl',
      // 'https://joeschmoe.io/api/v1/jon',
    );
    // return (
    //   this.value.avatarUrl ||
    //   'https://iconfont.alicdn.com/t/6bfa31ff-0a40-47b9-a08d-48429f2d7b7c.png'
    // );
  }
  /** 用户地址 */
  @computed
  public get userExtendDTO() {
    return (
      lodash.get(this.currentIdentityVOList, '[0].identityDomicileVO', {}) ||
      lodash.get(this.value, 'userAddress', {})
    );
  }
  /** 地址Str */
  @computed
  public get address() {
    if (this.isSales) {
      return ' ';
    }
    const address =
      lodash
        .compact([
          lodash.get(this.value, 'userExtendDTO.province'),
          lodash.get(this.value, 'userExtendDTO.city'),
          lodash.get(this.value, 'userExtendDTO.district'),
        ])
        .join(' / ') ||
      lodash
        .compact([
          lodash.get(this.value, 'userAddress.province'),
          lodash.get(this.value, 'userAddress.city'),
          lodash.get(this.value, 'userAddress.district'),
        ])
        .join(' / ');

    return address || '未设置地区';
  }

  @computed
  public get mobilePhone() {
    return lodash.get(this.value, 'mobile');
  }

  @computed
  public get isMobile() {
    // 不包含k码的就是手机登陆的
    const username = lodash.toLower(this.username);
    return !lodash.includes(username, 'k');
  }
  /** sales信息 */
  @computed
  public get salesInfo() {
    return lodash.get(this.value, 'salesInfo', {});
  }
  /** 绑定的 k */
  @computed
  public get businessAccount() {
    return lodash.get(this.value, 'channelId', '');
  }
  /** 商机用户存在K码 */
  @computed
  public get isKNumber() {
    const businessAccount = lodash.toLower(this.businessAccount);
    return lodash.includes(businessAccount, 'k');
  }

  /** 是否 可以操作商机 SMB & 合作伙伴 & level3 或 level4*/
  @computed
  public get isBusiness() {
    return (
      this.isSMB &&
      this.isCooperativePartner &&
      (this.isLevel3 || this.isLevel4) &&
      !this.isOnlyTypeId19
    );
  }

  /** 用户子类型 */
  @computed
  public get subUserType() {
    return lodash.get(this.value, 'subUserType');
  }

  /**
   * 获取Bu身份
   */
  @computed
  public get buRole() {
    let role = 'Partner';
    if (this.isIntendedPartner) return role;
    switch (this.BU) {
      case EnumBusiness.REL:
        role = 'REL';
        break;
      case EnumBusiness.CON:
        role = 'CON';
        break;
      case EnumBusiness.SMB:
        role = 'SMB';
        break;
      case EnumBusiness.ISG:
        role = 'ISG';
        break;
      default:
    }
    return role;
    // return 'SMB';
    // return 'ISG'; // cs
    // return 'CON'; // cs
    // return 'REL'; // cs
  }

  /**
   * 获取Bu身份
   */
  public setBuRole(buRole) {
    switch (buRole) {
      case 'REL':
        this.setBU(EnumBusiness.REL);
        break;
      case 'CON':
        this.setBU(EnumBusiness.CON);
        break;
      case 'SMB':
        this.setBU(EnumBusiness.SMB);
        break;
      case 'ISG':
        this.setBU(EnumBusiness.ISG);
        break;
      default:
    }
    // return 'SMB';
    // return 'ISG'; // cs
    // return 'CON'; // cs
    // return 'REL'; // cs
  }

  setBU(bu) {
    this.set({
      businessType: bu,
    });
    lodash.set(this.value, 'businessType', bu);
  }

  /**
   * 是否是云学堂用户
   */
  get isYxtUser() {
    return (
      this.isMobileLogin && (this.isSales || !lodash.isEmpty(this.identityId))
    );
  }

  /**
   * 是否允许SN上报
   */
  @computed
  get allowedSNReport() {
    return lodash.get(this.value, 'allowedSNReport');
  }

  /** 是否ISG经销商 */
  @computed
  public get isISGReseller() {
    return lodash.some(this.channelTypeList, (channel) => {
      return lodash.includes(['81'], lodash.get(channel, 'typeId'));
    });
  }
  /**bu是SMB 并且 typeId只有19（商用服务商）*/
  @computed
  get isOnlyTypeId19() {
    return (
      this.channelTypeList &&
      this.channelTypeList.length == 1 &&
      lodash.eq(this.channelTypeList[0].typeId, '19')
    );
  }

  /** 是否T1服务商 */
  @computed
  public get isT1Service() {
    return lodash.some(this.channelTypeList, (channel) => {
      return lodash.includes(
        [EnumRelSubType.Servier],
        lodash.get(channel, 'subtypeId'),
      );
    });
  }

  /** 销量划转用户 */
  @computed
  public get marketOrder() {
    // smb已签约的签约商
    return lodash.some(this.currentIdentityVOList, (item) => {
      const intersection = lodash.intersection(
        ['582', '111', '171'],
        lodash.split(item.roleIdContent, ','),
      );
      return (
        item.cooperateType == EnumCooperateType.Signing &&
        item.businessType == EnumBusiness.SMB &&
        item.signingStatus == true &&
        !lodash.isEmpty(intersection) // 手机号只有管理员和销售
      );
    });
  }
  /**
   @ 埋点 组合的用户信息
   * UID    => 用户userID
   * BU     => 所属BU(SMB|REL|CON|ISG)
   * ROLE   => 角色（注册商 or 签约商）
   * UT     => 用户类型 UserType
   * SUT    => 用户子类型：SubUserType
   * SIGNED => 是否签约（0 or 1）
   * ISATT  => 是否认证(0 or 1)
   * UL     =>  用户等级 UserLevel(1-4)
   */
  // @computed
  // public get _la_lenovo_userInfo() {
  //   const userIf = lodash.pickBy({
  //     UID:this.id,
  //     // BU:'',
  //     ROLE:this.resellerType,
  //     UT:this.userType,
  //     SUT:this.subUserType,
  //     // SIGNED:'',
  //     ISATT:this.isAttestation,
  //     UL:this.levelCode
  //   },lodash.identity)
  //   return lodash.join(lodash.map(userIf,(value,key)=>`${key}:${value}`),';')
  // }
}
export const onCreateFactoryUser = UserModel.onCreateFactoryUser;
